"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Compare = void 0;
class Compare {
  // --------------------- compare
  compare(options) {
    const {
      c1,
      c2,
      complex
    } = options;
    if (complex === true && c1?.__name === 'lab' && c2?.__name === 'lab') {
      return this.CIE2000({
        c1,
        c2
      });
    }
    return this.CIE76({
      c1,
      c2
    });
  }
  // --------------------- compare
  // eslint-disable-next-line class-methods-use-this
  CIE76(options) {
    const {
      c1,
      c2
    } = options;
    // compare rgb liniar
    if (c1 && c2) {
      let comparisonResult = 0;
      const keys = Object.keys(c2);
      // eslint-disable-next-line no-restricted-syntax
      for (const key of keys) {
        const c1Number = c1[key];
        const c2Number = c2[key];
        comparisonResult += (c1Number - c2Number) ** 2;
      }
      return Math.sqrt(comparisonResult);
    }
    return false;
  }
  CIE2000(options) {
    const {
      c1,
      c2
    } = options;
    // compare lab
    const C1 = Math.sqrt(c1.a ** 2 + c1.b ** 2);
    const C2 = Math.sqrt(c2.a ** 2 + c2.b ** 2);
    const aC1C2 = (C1 + C2) / 2.0;
    const G = 0.5 * (1 - Math.sqrt(aC1C2 ** 7.0 / (aC1C2 ** 7.0 + 25.0 ** 7.0)));
    const a1p = (1 + G) * c1.a;
    const a2p = (1 + G) * c2.a;
    const C1p = Math.sqrt(a1p ** 2 + c1.b ** 2);
    const C2p = Math.sqrt(a2p ** 2 + c2.b ** 2);
    const h1p = this.hpf(c1.b, a1p);
    const h2p = this.hpf(c2.b, a2p);
    const dLp = c2.l - c1.l;
    const dCp = C2p - C1p;
    const dhp = this.dhpf(C1, C2, h1p, h2p);
    const dHp = 2 * Math.sqrt(C1p * C2p) * Math.sin(this.toRadians(dhp) / 2.0);
    const aL = (c1.l + c2.l) / 2.0;
    const aCp = (C1p + C2p) / 2.0;
    const ahp = this.ahpf(C1, C2, h1p, h2p);
    const T = 1 - 0.17 * Math.cos(this.toRadians(ahp - 30)) + 0.24 * Math.cos(this.toRadians(2 * ahp)) + 0.32 * Math.cos(this.toRadians(3 * ahp + 6)) - 0.2 * Math.cos(this.toRadians(4 * ahp - 63));
    const dro = 30 * Math.abs(-(((ahp - 275) / 25) ** 2));
    const RC = Math.sqrt(aCp ** 7.0 / (aCp ** 7.0 + 25.0 ** 7.0));
    const SL = 1 + 0.015 * (aL - 50) ** 2 / Math.sqrt(20 + (aL - 50) ** 2.0);
    const SC = 1 + 0.045 * aCp;
    const SH = 1 + 0.015 * aCp * T;
    const RT = -2 * RC * Math.sin(this.toRadians(2 * dro));
    return Math.sqrt((dLp / (SL * 1)) ** 2 + (dCp / (SC * 1)) ** 2 + (dHp / (SH * 1)) ** 2 + RT * (dCp / (SC * 1)) * (dHp / (SH * 1)));
  }
  // --------------------- helpers for cie2000
  // eslint-disable-next-line class-methods-use-this
  toDegrees(radians) {
    return radians * (180 / Math.PI);
  }
  // eslint-disable-next-line class-methods-use-this
  toRadians(degrees) {
    return degrees * (Math.PI / 180);
  }
  hpf(x, y) {
    if (x === 0 && y === 0) {
      return 0;
    }
    const tmphp = this.toDegrees(Math.atan2(x, y));
    if (tmphp >= 0) {
      return tmphp;
    }
    return tmphp + 360;
  }
  // eslint-disable-next-line class-methods-use-this
  dhpf(C1, C2, h1p, h2p) {
    if (C1 * C2 === 0) {
      return 0;
    }
    if (Math.abs(h2p - h1p) <= 180) {
      return h2p - h1p;
    }
    if (h2p - h1p > 180) {
      return h2p - h1p - 360;
    }
    if (h2p - h1p < -180) {
      return h2p - h1p + 360;
    }
    throw new Error(`Something went wrong in dhpf: ${C1}, ${C2}, ${h1p}, ${h2p}`);
  }
  // eslint-disable-next-line class-methods-use-this
  ahpf(C1, C2, h1p, h2p) {
    if (C1 * C2 === 0) {
      return h1p + h2p;
    }
    if (Math.abs(h1p - h2p) <= 180) {
      return (h1p + h2p) / 2.0;
    }
    if (Math.abs(h1p - h2p) > 180 && h1p + h2p < 360) {
      return (h1p + h2p + 360) / 2.0;
    }
    if (Math.abs(h1p - h2p) > 180 && h1p + h2p >= 360) {
      return (h1p + h2p - 360) / 2.0;
    }
    throw new Error(`Something went wrong in ahpf: ${C1}, ${C2}, ${h1p}, ${h2p}`);
  }
}
exports.Compare = Compare;
const compare = new Compare();
var _default = exports.default = compare.compare.bind(compare);